import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";
import store from "@/general/store";
import axios from "axios";

@Module({
  name: "thanksChat",
  namespaced: true,
  store,
  dynamic: true
})
class ThanksChatModule extends VuexModule {
  chatLog: any = [];
  threadId = 0;

  @Mutation
  setChatLog(chatLog: any) {
    this.chatLog = this.chatLog.concat(chatLog);
  }

  @Mutation
  addChatLog(chatLog: any) {
    this.chatLog = chatLog;
  }

  @Mutation
  setThreadId(threadId: number) {
    this.threadId = threadId;
  }

  @Action
  async getChatLog() {
    const getResponse = await axios.get("/api/general/point/chat/", {
      params: {
        id: this.threadId
      }
    });

    this.context.commit("setChatLog", getResponse.data);

    axios
      .put("/api/general/point/chat/", {
        params: {
          id: this.threadId
        }
      })
      .then(postResponse => {
        console.log(postResponse);
      })
      .catch(postError => {
        console.log(postError);
      });
  }

  @Action
  doSend() {
    axios
      .post("/api/general/point/chat/", {
        params: {
          id: this.threadId
        }
      })
      .then((response: any) => {
        const { data } = response;
        this.context.commit("setChatLog", data);
      })
      .catch((error: any) => {
        console.log(error);
      });
  }
}

export default getModule(ThanksChatModule);
